import type { KeycloakUserData } from '@liks/backend-svc-api/esm/models/index';
import type { CurrentUserProfile } from '../types/user';
import { calendarValidityToIsoRange } from '../utils/dateTimeUtils';
import {
  pickUserEnabledField,
  pickUserOptimisticLockFields,
} from '../utils/userUpdateUtils';
import type { UpdateDirectoryUserInput } from './userServiceTypes';

export function toDirectoryEnabledUserPayload(
  profile: CurrentUserProfile,
  enabled: boolean,
): KeycloakUserData {
  return {
    ...profile,
    enabled,
  };
}

export function buildDirectoryUserUpdatePayload(
  input: UpdateDirectoryUserInput,
) {
  const validity = calendarValidityToIsoRange(input);

  return {
    ...pickUserOptimisticLockFields(input),
    username: input.username,
    email: input.email,
    firstName: input.firstName,
    lastName: input.lastName,
    ...pickUserEnabledField(input.enabled),
    ...validity,
  };
}
